import React from 'react';

const StudySection = ({ refProp, title, imageSrc, description, links, onScroll, buttonText }) => (
  <section ref={refProp} className="study-section">
    <h2>{title}</h2>
    <img src={imageSrc} alt="" />
    <p>{description}</p>
    {links && (
      <ul>
        {links.map((link, index) => (
          <li key={index}>
            <a href={link.href} target="_blank" rel="noopener noreferrer">{link.text}</a>
          </li>
        ))}
      </ul>
    )}
    <button onClick={onScroll} className="download-button">{buttonText || "Additional Resources"}</button>
  </section>
);

export default StudySection;
